import React from "react"

import Logo from "../images/logo.png"

const LoadingSplashScreen = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexFlow: "row wrap",
      }}
    >
      <div style={{ textAlign: "center" }} className="fade-in-long">
        <img
          src={Logo}
          alt="EzTrain Logo"
          style={{ width: "50%", flexBasis: "100%" }}
        />
        <br />
        <h3 style={{ fontSize: "2.5rem", marginBottom: "0" }}>404</h3>
        <br />
        <p>The page you are looking for does not exist</p>
      </div>
    </div>
  )
}

export default LoadingSplashScreen
